export default __webpack_public_path__ + "6c0bee9a9dc03a141e428f7fd6bcb799.jpg";